import { createAction, props } from '@ngrx/store';
import { Region, RegionID } from '@immosky/types';

export enum RegionActions {
  Reset = '[Filter] Reset Region Filter',
  Add = '[Filter] Add Region Filter',
  SetRegions = '[Filter] Set Regions Filter',
  Remove = '[Filter] Remove Region Filter',
  SetBasedOnUrlValues = '[Filter] Set Region Filter Based On Values',
  SetInitialSearchTerm = '[Filter] Set Initial Search Term',
}

export const resetRegionFilter = createAction(RegionActions.Reset);

export const addRegionFilter = createAction(
  RegionActions.Add,
  props<{ region: Region }>()
);

export const setRegionsFilter = createAction(
  RegionActions.SetRegions,
  props<{ regions: Region[] }>()
);

export const removeRegionFilter = createAction(
  RegionActions.Remove,
  props<{ region: Region }>()
);

export interface RegionIDsProp {
  regionIDs: RegionID[];
}

export const setRegionFiltersBasedOnUrl = createAction(
  RegionActions.SetBasedOnUrlValues,
  props<RegionIDsProp>()
);

export const setInitialSearchTerm = createAction(
  RegionActions.SetInitialSearchTerm,
  props<{ term: string }>()
);
